/**
 * The maintenance module's paths — spec §8.6.
 *
 * `/maintenance` is what `layout/nav-items.ts` already points its `maintenance` entry
 * at, gated on `maintenance:read`, so the prefix is not this phase's to choose.
 *
 * ─── THE BOARD IS THE ROOT, THE VEHICLE VIEW HANGS OFF IT ───────────────────
 *
 * A workshop arrives with "what needs doing this week", not with a registration. The
 * reverse nesting (`/vehicles/:id/maintenance`) would make the Monday-morning screen
 * unreachable without first choosing the vehicle nobody has identified yet — the same
 * argument `features/diagnostics/routes.ts` makes for its fleet view.
 *
 * Route paths stay in English while the UI defaults to French: the address bar is not
 * a translated surface, and a localized set would mean two routing tables and a
 * redirect on every language switch.
 *
 * Registration lives in `routes/app-routes.tsx`, which this phase does not own.
 * NOTES-PHASE9-WEB-A.md §1 carries the patch, and it MUST lazy-load this module's
 * barrel — importing it registers the FR/EN catalogue as a side effect.
 */

export const MAINTENANCE_PATH = '/maintenance'
export const VEHICLE_MAINTENANCE_PATH = '/maintenance/vehicles/:vehicleId'
/** Papiers & vidange: the fleet's papers and oil changes on one screen. */
export const PAPERS_PATH = '/maintenance/papers'

export const MAINTENANCE_QUERY_KEYS = {
  /** `overdue` | `warning` | `ok` | `cannot_evaluate`. */
  state: 'state',
  vehicleId: 'vehicle',
  fleetId: 'fleet',
  /**
   * How far ahead a calendar item counts as "coming up", in days. On the URL rather
   * than in component state so a manager forwarding "eleven items due" sends a link
   * that reproduces the same eleven — a count without its horizon is a number two
   * people read differently and both are right.
   */
  horizonDays: 'horizon',
} as const

export function vehicleMaintenancePath(vehicleId: string): string {
  return `${MAINTENANCE_PATH}/vehicles/${vehicleId}`
}

/** A deep link into one severity band. What a board tile links to. */
export function maintenanceBoardPath(
  state?: 'overdue' | 'warning' | 'ok' | 'cannot_evaluate',
): string {
  return state === undefined
    ? MAINTENANCE_PATH
    : `${MAINTENANCE_PATH}?${MAINTENANCE_QUERY_KEYS.state}=${state}`
}
